import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './UserGroupListItem';

import UserGroupActions from '../../actions/UserGroupActionCreator';
import UserGroupStore from '../../stores/UserGroupStore';

import ErrorSnackbar from '../Common/ErrorSnackbar';


class UserGroupList extends Component {

    constructor (props) {
        super(props);
        this.state = {
            usergroups: [],
            count: 0,
            page: 0,
            limit: 50,
            sortCriteria: null,
            sortMapCriteria: null
        };
        this.onChange = this.onChange.bind(this);
        this.sort = this.sort.bind(this);
    }

    componentDidMount() {
        UserGroupStore.addChangeListener(this.onChange);
        UserGroupActions.getAll({limit: this.state.limit});
    }

    componentWillUnmount() {
        UserGroupStore.removeChangeListener(this.onChange);
    }

    render() {
        return (
            <div>
            <ListView
                title="User groups"
                sortOptions={this.props.sortOptions}
                sortAction={this.sort}
                searchAction={UserGroupActions.search}
                items={this.state.usergroups}
                itemDecorator={ListItem}
                newEntityUrl={this.context.auth.isRootAdmin() ? '/dashboard/usergroup/new' : ''}
            />
            <ErrorSnackbar/>
            </div>
        )
    }

    onChange() {
        const usergroups = UserGroupStore.getAll({limit: this.state.limit});
        if (!!usergroups) {
            if (usergroups.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({usergroups});
            } else {
                const mapped = usergroups.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedUserGroups = mapped.map((el) => usergroups[el.index]);
                this.setState({usergroups: sortedUserGroups});
            }
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'dateAdded':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateAdded)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        UserGroupActions.getAll({sort: options.sort});
    }

}

UserGroupList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Created", value: 'dateAdded'}
     ]
};

UserGroupList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default UserGroupList;
